exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".area-sub-footer-container{grid-area:sub-footer;padding:0 28px 0 46px}.area-sub-footer-container .link{color:#6e6e6e;font-size:12px;font-weight:700;text-decoration:none;margin:0 18px 14px 0;white-space:nowrap;display:inline-block}", ""]);

